<script setup lang="ts">
import { useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import RvApi from "@/rvapi";
import type { Device, LegacyDevice } from "@/rvapi";
import LogList from "@/components/LogList.vue";
import OrderList from "@/components/OrderList.vue";
import LogWriter from "@/components/LogWriter.vue";
import LegacyDeviceDetails from "@/components/LegacyDeviceDetails.vue";
import { alert_exclamation_circle } from "pn-design-assets/pn-assets/icons";
const route = useRoute();
const deviceId = ref(route.params.id as string);
const device = ref(undefined as LegacyDevice | undefined);
const newDevice = ref(undefined as Device | undefined);
const loaded = ref(false);
onMounted(async () => {
  const newdevicesPromise = RvApi.searchDevices(deviceId.value);
  const olddevicePromise = RvApi.searchLegacyDevice(deviceId.value);
  const newdevices = await newdevicesPromise;
  if (newdevices && newdevices.length > 0) {
    newDevice.value = newdevices[0];
  }

  const olddevices = await olddevicePromise;
  if (olddevices && olddevices.length > 0) {
    device.value = olddevices[0];
  }

  loaded.value = true;
});
</script>

<template>
  <h1>Legacy Device</h1>
  <pn-spinner size="4" v-show="!loaded" />
  <div v-if="!device && loaded">No device found</div>
  <section v-if="newDevice">
    <pn-toast closable="false">
      This device has been migrated, the new device can be found
      <a :href="`/device/${newDevice.deviceId}`">here</a>.
    </pn-toast>
  </section>
  <section v-if="!newDevice">
    <p>
      This is a device with a version of the app that is older than v5.12, and
      thus the data we have for it has not been completely migrated to our new
      systems.
    </p>
  </section>

  <section v-if="device">
    <h2>Details</h2>

    <LegacyDeviceDetails :simple="false" :device="device" />
  </section>
  <section v-if="!!device">
    <pn-toast
      :icon="alert_exclamation_circle"
      closable="false"
      text="Orders made before June 2021 might not show up in this list."
    >
    </pn-toast>
    <OrderList type="device" :searchId="deviceId" />
  </section>
  <section v-if="!!device">
    <LogWriter :deviceId="deviceId" />
  </section>
  <section v-if="!!device">
    <LogList type="device" :searchId="deviceId" />
  </section>
</template>
